/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageRef = "appointmentOffer" | "botFollowup" | "broadcast" | "chat" | "chatAudit" | "chatAuditTz" | "chatNotification" | "feedback" | "feedbackReminder" | "followup" | "formReminder" | "generic" | "outboundReferralOutreach" | "outboundReferralReminder" | "pinVerification" | "referralFollowup" | "referralRedirect" | "referralReminder" | "reminder" | "reschedule" | "stop" | "telehealth" | "waitingRoomPatient" | "waitlist" | "waitlistOffer" | "%future added value";
export type EnumMessageType = "inbound" | "outbound" | "%future added value";
export type EnumMessageVisibility = "internal" | "private" | "public" | "%future added value";
export type ChatMessage_Message = {
    readonly automated: boolean | null;
    readonly createdAt: unknown | null;
    readonly oid_file: string | null;
    readonly ref: EnumMessageRef | null;
    readonly text: string | null;
    readonly type: EnumMessageType | null;
    readonly visibility: EnumMessageVisibility | null;
    readonly mentions: ReadonlyArray<{
        readonly mention: string | null;
    } | null> | null;
    readonly createdBy: {
        readonly name: string | null;
        readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node">;
    } | null;
    readonly patient: {
        readonly name: string | null;
        readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"TypographyMessageDetails_Message">;
    readonly " $refType": "ChatMessage_Message";
};
export type ChatMessage_Message$data = ChatMessage_Message;
export type ChatMessage_Message$key = {
    readonly " $data"?: ChatMessage_Message$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChatMessage_Message">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "includeDeleted",
    "value": true
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "AvatarNode_Node"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatMessage_Message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "automated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oid_file",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ref",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageMentions",
      "kind": "LinkedField",
      "name": "mentions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mention",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "createdBy(includeDeleted:true)"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "patient(includeDeleted:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyMessageDetails_Message"
    }
  ],
  "type": "Message",
  "abstractKey": null
};
})();
(node as any).hash = 'f81939f0e8e87ed7b489c52b9c956f55';
export default node;
